// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Source: dsl/entities/PlanLine.yaml
// Generated: 2026-06-02T14:10:13.096Z
// </auto-generated>

import type { AuditedEntityBase, ConcurrencyStamped } from '../base';

/**
 * The concrete planned amount per (Account x DimensionSet x FiscalPeriod) — the exact tuple a posted JournalLine carries (plan-vs-actual is a direct join). An AGGREGATE ROOT (not a child of PlanHeader): a PlanLine is individually derived / resolved / recomputed through its own MappingStatus lifecycle + commands and is bulk-imported by the thousands, so it owns its own repository / commands / state machine rather than being loaded inside the PlanHeader aggregate. It references its owning header by planHeaderId FK (DB cascade on header delete) and is surfaced under the header via a relatedViews master-detail grid (PlanHeader is referenced by id, not a loaded collection — ABP aggregate boundaries intact). Carries the FinancialDerivationEngine delta (accountId, dimensionSetId, mappingStatus, mappingReason + the RESOLVED<->PENDING lifecycle). Stored form = AccountId + DimensionSetId + Amount + Quantity + UoM + UnitPrice. Owned (design) by PlanBudgetDatamodell.
 */
export interface PlanLine extends AuditedEntityBase, ConcurrencyStamped {
  /** The plan this line belongs to. */
  planHeaderId: string;
  /** PlanHeader name (for display) */
  planHeaderName?: string;
  /** The version this line belongs to. */
  planVersionId: string;
  /** PlanVersion label (for display) */
  planVersionLabel?: string;
  /** GL account, derived by the account rules. Empty until the line is resolved. */
  accountId?: string;
  /** Account name (for display) */
  accountName?: string;
  /** Resolved dimension values for the line. */
  dimensionSetId?: string;
  /** DimensionSet displayValue (for display) */
  dimensionSetDisplayValue?: string;
  /** The period the amount applies to. */
  fiscalPeriodId: string;
  /** FiscalPeriod name (for display) */
  fiscalPeriodName?: string;
  /** Planned volume behind the amount. */
  quantity?: number;
  /** Unit for the quantity. */
  unitOfMeasureId?: string;
  /** UnitOfMeasure name (for display) */
  unitOfMeasureName?: string;
  /** Per-unit price in base currency. */
  unitPrice?: number;
  /** Planned amount in base currency. */
  amount: number;
  /** Resolved (publishable) or Pending (needs attention before publish). (dynamic enum: MappingStatus) */
  mappingStatus: string;
  /** Why the line is pending. Empty when resolved. (dynamic enum: MappingReason) */
  mappingReason?: string;
  /** The prior-version line this was carried over from. */
  sourceLineId?: string;
  /** SourceLine notes (for display) */
  sourceLineNotes?: string;
  /** The generated internal-revenue line paired with this cost line (empty = none). */
  linkedRevenueLineId?: string;
  /** The internal price line that produced this revenue line (empty = not a revenue line). */
  matchedPriceLineId?: string;
  /** [base] Free-text note. */
  notes?: string;
}

/**
 * Create PlanLine DTO
 * Note: Scope is NOT included - it's derived by backend from user session context
 */
export interface CreatePlanLine {
  /** The plan this line belongs to. */
  planHeaderId: string;
  /** GL account, derived by the account rules. Empty until the line is resolved. */
  accountId?: string;
  /** Resolved dimension values for the line. */
  dimensionSetId?: string;
  /** The period the amount applies to. */
  fiscalPeriodId: string;
  /** Planned volume behind the amount. */
  quantity?: number;
  /** Unit for the quantity. */
  unitOfMeasureId?: string;
  /** Per-unit price in base currency. */
  unitPrice?: number;
  /** Planned amount in base currency. */
  amount: number;
  /** Resolved (publishable) or Pending (needs attention before publish). (dynamic enum: MappingStatus) */
  mappingStatus: string;
  /** Why the line is pending. Empty when resolved. (dynamic enum: MappingReason) */
  mappingReason?: string;
  /** The prior-version line this was carried over from. */
  sourceLineId?: string;
  /** The generated internal-revenue line paired with this cost line (empty = none). */
  linkedRevenueLineId?: string;
  /** The internal price line that produced this revenue line (empty = not a revenue line). */
  matchedPriceLineId?: string;
  /** [base] Free-text note. */
  notes?: string;
}

/**
 * Update PlanLine DTO
 */
export interface UpdatePlanLine {
  /** The plan this line belongs to. */
  planHeaderId: string;
  /** GL account, derived by the account rules. Empty until the line is resolved. */
  accountId?: string;
  /** Resolved dimension values for the line. */
  dimensionSetId?: string;
  /** The period the amount applies to. */
  fiscalPeriodId: string;
  /** Planned volume behind the amount. */
  quantity?: number;
  /** Unit for the quantity. */
  unitOfMeasureId?: string;
  /** Per-unit price in base currency. */
  unitPrice?: number;
  /** Planned amount in base currency. */
  amount: number;
  /** Resolved (publishable) or Pending (needs attention before publish). (dynamic enum: MappingStatus) */
  mappingStatus: string;
  /** Why the line is pending. Empty when resolved. (dynamic enum: MappingReason) */
  mappingReason?: string;
  /** The prior-version line this was carried over from. */
  sourceLineId?: string;
  /** The generated internal-revenue line paired with this cost line (empty = none). */
  linkedRevenueLineId?: string;
  /** The internal price line that produced this revenue line (empty = not a revenue line). */
  matchedPriceLineId?: string;
  /** [base] Free-text note. */
  notes?: string;
  /** The PlanLine's concurrencyStamp as loaded; a stale one is refused when a header field changes */
  concurrencyStamp?: string;
}


/**
 * The decimal places each Decimal field of PlanLine stores: its column's scale. A value with more is rounded
 * half away from zero when it is stored.
 */
export const PlanLineScales = {
  quantity: 2,
  unitPrice: 2,
  amount: 2,
} as const;

